
<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="contract_info"
                        arrows >
                    <template slot="gofixTab:contract_info">
                        <gofix-card title="Contract Details" >
                            <template slot="gofixCard:right_header">
                                <div class="d-flex justify-content-end align-items-center">
                                    <span class="spanStatus mr-4">{{clientContract.status}}</span>
                                    <gofix-button class="mr-4" label="Change Status" @click="modalStatus" :disabled="!$checkRole($accessModule.contractinfo, 'update')" outline></gofix-button>
                                    <span class="mr-2"><img src="img/icon-ellipse.png"></span>
                                    <b-button @click="print" class="mr-3 clientPrintIcon" title="Print" v-b-tooltip.hover><i class="icon-printer icons"></i></b-button>
                                    <b-button class="mr-4 clientPaperIcon" @click="activeDown = !activeDown" title="Attachment" v-b-tooltip.hover><i class="icon-paper-clip"></i><span class="badge">{{clientContract.main_contract.length + clientContract.terms_option.length + clientContract.extension_period_main.length + clientContract.extra_info.length + clientContract.contract_variation_info.length}}</span></b-button>
                                    <gofix-button
                                            label="Save"
                                            @click="saveClientContract"
                                            :loading="disabled"
                                            :disabled="disabled || !$checkRole($accessModule.contractinfo, 'update') || (clientContract.status !='Draft' && clientContract.status !='Reopening')"></gofix-button>
                                </div>
                            </template>
                            <b-row class="">
                                <b-col md="4">
                                    <gofix-form-input label="contract name" v-model="$v.clientContract.contract_name.$model" required></gofix-form-input>
                                </b-col>
                                <b-col md="4">
                                    <gofix-form-dropdown
                                            label="Client"
                                            :disabled="clientContract.status == 'Active'"
                                            :value="clientContract.client"
                                            :options="clients"
                                            vLabel="name"
                                            :filterable="false"
                                            @search="searchOrganization"
                                            @change="selectClient">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input :disabled="clientContract.status === 'Active'" label="Abbreviation" v-model="clientContract.abbreviation" maxlength="3" ></gofix-form-input>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-number
                                                label="contract sum"
                                                v-if="clientContract.terms_base[0]"
                                                v-model="clientContract.terms_base[0].contract_sum"
                                                prefix="$">
                                            </gofix-form-input-number>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="" v-for="(item, index) in clientContract.terms_base" :key="index">
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                v-model="item.extra_info.loaDate"
                                                label="LOA date">
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                v-model="item.extra_info.agreementDate"
                                                label="agreement signing date">
                                            </gofix-form-input-date>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row >
                                        <template v-if="index == 0">
                                            <b-col md="6">
                                                <gofix-form-input-date
                                                    :disabled="clientContract.contract_terms.length > 1"
                                                    v-model="item.start_date"
                                                    label="contract commencement date">
                                                </gofix-form-input-date>

                                            </b-col>
                                            <b-col md="6">
                                                <gofix-form-input-date
                                                    :minDate="new Date()"
                                                    :disabled="clientContract.contract_terms.length > 1"
                                                    v-model="item.end_date"
                                                    label="contract expiry date">
                                                </gofix-form-input-date>
                                            </b-col>
                                        </template>
                                    </b-row>
                                </b-col>
                                <b-col md="2" class="custom-cases gofixLogoContract">
                                    <gofix-text-field label="Client Logo" class="editPhotoValue" classLabel="font-14" classValue="pl-0" classInner="d-block" oneline>
                                        <div class="d-flex align-items-center viewer mt-11">
                                            <template v-if="clientContract.town_council_logo">
                                                <viewer-image :images="clientContract.town_council_logo" classViewer='d-flex align-items-center'>
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb list-unstyled max-width-per-100 mb-0">
                                                            <li class="mb-0 mr-10" v-for="(item, key) in images" v-bind:key="key">
                                                                <img v-auth-image="item.url.original" :alt="item.image_file_name || 'image'"  src="img/loading.gif">
                                                            </li>
                                                        </ul>
                                                    </template>    
                                                </viewer-image>
                                            </template>
                                            <div class="upload-btn-wrapper m-0">
                                                <b-form-file v-model="attachmentLogo" accept=".jpg, .png, .gif" plain></b-form-file>
                                                <gofix-button :label="!clientContract.town_council_logo || !clientContract.town_council_logo.length ? 'ADD PHOTO' : 'CHANGE PHOTO'" outline></gofix-button>
                                            </div>
                                        </div>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="2">
                                    <gofix-button
                                            class="mt-2"
                                            :label="'Related Supplier Contracts (' + (clientContract.related_supplier_contracts_count || 0 ) + ')'"
                                            @click="relatedSuppliers"
                                            noBorder fontNormal></gofix-button>
                                    <b-modal :no-close-on-backdrop="true" :title="`Related Contracts (${clientContract.related_supplier_contracts_count || 0})`" ref="search-client" id="search-client" hide-footer ::no-close-on-backdrop="true" :no-close-on-esc="true">
                                        <ul class="list-unstyled list-client" v-if="relatedSupplier.total > 0" v-bind:class="{'run-loading':Loadings.list}">
                                            <template v-for="(item, index) in relatedSupplier.data">
                                                <li v-bind:key="item.id">
                                                    <router-link :to="`/v2/contract-supplier/${item.id}`" class="custom-link">
                                                        {{ item.contract_name }}
                                                        <small>{{ item.supplier && item.supplier.name ? item.supplier.name : '--' }}</small>
                                                        <small>From: {{ item.terms_base[0].start_date | formatsDate }} to {{ item.terms_base[0].end_date | formatsDate }}</small>
                                                    </router-link>
                                                </li>
                                            </template>
                                        </ul>
                                        <gofix-form-dropdown
                                                class="mt-2"
                                                label="Select Supplier"
                                                v-model="clientsSupplierSelected"
                                                :options="clientsSupplier"
                                                :filterable="false"
                                                :append-to-body="true"
                                                @search="searchOrganizationSupplier"
                                                @change="selectOrganization"
                                                vLabel="name">
                                            <template #gofixInput:dropdown::option="option">
                                                <div class="custom-option-select" v-bind:class="{'active':listIDSupplierRelated.includes(option.id)}">
                                                    <label class="label-contract">{{option.name}}</label>
                                                </div>
                                            </template>
                                        </gofix-form-dropdown>
                                        <b-row>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                        label="SOR Adjustment Mark"
                                                        :options="adjustmentMark"
                                                        v-model="type"
                                                        :filterable="false">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="6">
                                                <gofix-form-input-number
                                                        label="SOR adjustment (%)"
                                                        :integer-limit="3"
                                                        v-model="sor_adjustment"
                                                        suffix="%">
                                                </gofix-form-input-number>
                                            </b-col>
                                        </b-row>
                                        <gofix-button
                                                label="Supplier contract +"
                                                @click="$refs['modal-confirm'].show()"
                                                :loading="isAction" outline>
                                        </gofix-button>
                                    </b-modal>
                                </b-col>
                            </b-row>
                            <b-row class="mt-10">
                                <b-col md="4">
                                    <gofix-form-dropdown
                                        label="Debtor Code"
                                        :filterable="false"
                                        :clearable="true"
                                        :required="false"
                                        v-model="clientContract.debtor_code"
                                        vLabel="source_code"
                                        :reduce="option => option.source_code"
                                        :options="debtorCodeOptions"
                                        @search="loadDebtorCode">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="2">
                                    <!--  -->
                                    <gofix-form-input 
                                        label="HDB TC Code" 
                                        v-model="clientContract.hdb_tc_code">
                                    </gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3" v-if="$checkRole($accessModule.contractinfo, 'create')">
                                <b-col md="12">
                                    <div class="btnGroupPlus">
                                        <gofix-button class="mr-3" label="option period +" @click="addOption('terms_option', 'option')" outline></gofix-button>
                                        <gofix-button class="mr-3" label="extension period +" @click="addOption('extension_period_main', 'extension')" outline></gofix-button>
                                        <gofix-button class="mr-3" label="add security deposit +" @click="addOption('extra_info', 'extra_info')" outline></gofix-button>
                                        <gofix-button label="add contract vari. +" @click="addOption('contract_variation_info', 'contract_variation_info')" outline></gofix-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </gofix-card>

                        <!-- Attachment -->
                        <contract-attachment :is_active="activeDown" :contract="clientContract"></contract-attachment>

                        <terms-option :terms-option="clientContract.terms_option" @removeItem="removeOption"></terms-option>
                        <extension-period :value="clientContract.extension_period_main" @removeItem="removeOption"></extension-period>
                        <extra-info :value="clientContract.extra_info" @removeItem="removeOption" @clone="clonePublic"></extra-info>
                        <variation-info :value="clientContract.contract_variation_info" @removeItem="removeOption"></variation-info>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-confirm">
            <div class="center">Do you want to create<br>a supplier contract?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-confirm'].hide()">No</b-button>
                <b-button class="custom-btn" @click="creatSupplierQuick">Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Change Status" hide-footer :centered="true" ref="modal-Status">
            <b-form>
                <gofix-form-dropdown
                        label="Next Action"
                        vLabel="label"
                        v-model="contract_status"
                        required
                        :reduce="option => option.value"
                        :options="statusData[clientContract.status]">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="updateStatus" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <contract-print :client-contract="clientContract" ref="contractPrint"></contract-print>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'
    const contractAttachment = () => import("./contract-attachment_v2")
    const contractPrint = () => import("./main-info/print")
    const termsOption = () => import("./main-info/terms_option")
    const extensionPeriod = () => import("./main-info/extension_period")
    const extraInfo = () => import("./main-info/extra_info")
    const variationInfo = () => import("./main-info/variation_info")
    const ViewerImage = () => import('../plugins/ViewerImage.vue')

    import moment from 'moment';
    const accounting = require('accounting');
    export default {
        name: 'contract-info',
        components: {
            contractAttachment,
            contractPrint,
            termsOption,
            extensionPeriod,
            extraInfo,
            variationInfo,
            ViewerImage
        },
        data() {
            return {
                contract_tab:tabData.client_contract,
                activeDown: true,
                contract_status: null,
                adjustmentMark: [
                    {
                      value: 'up',
                      label: 'Mark Up'
                    },
                    {
                      value: 'down',
                      label: 'Mark Down'
                    }
                ],
                type: {
                    value: 'up',
                    label: 'Mark Up'
                },
                sor_adjustment: null,
                selectedClone: false,
                disabled: false,
                clients: [],
                clientsSupplier: [],
                clientContract: {
                    client: null,
                    client_id: 1,
                    terms_base: [],
                    terms_option: [],
                    main_contract: [],
                    option_period: [],
                    extention_period: [],
                    security_deposit: [],
                    work_injury_compensation: [],
                    public_liability_claim_insurence: [],
                    contract_variation: [],
                    extension_period_main: [],
                    extra_info: [],
                    contract_variation_info: [],
                    dept_code: '',
                    town_council_logo: [],
                    debtor_code: '',
                    hdb_tc_code: null
                },
                isAction: false,
                clientsSupplierSelected: null,
                supplier: {
                    contract_id : '',
                    client_id: '',
                    sor_adjustment: '',
                },
                listIDSupplierRelated: [],
                extra_info_ids: [],
                contractStatus:{
                    Draft : ['Draft','Active'],
                    Active : ['Draft','Active','Terminated','Reopening'],
                    Terminated : ['Draft','Active','Terminated','Reopening'],
                    Reopening : ['Draft','Active','Reopening'],
                    //['Draft','Active','Expired','Terminated','Reopening']
                },
                debtorCodeOptions:[],
                statusData:{
                    "Draft" : [
                        {
                            value: "Active",
                            label: "Submit"
                        }
                    ],
                    "Active" : [
                        {
                            value: "Reopening",
                            label: "Reopen"
                        },
                        {
                            value: "Terminated",
                            label: "Terminate"
                        }
                    ],
                    "Reopening" : [
                        {
                            value: "Active",
                            label: "Submit"
                        }
                    ]
                },
                attachmentLogo: null
            }
        },
        mixins: [validationMixin],
        validations: {
            clientContract: {
                contract_name: {
                    required
                }
            }
        },
        filters: {
            formatsDate: function(value) {
                if (!value) return "N/A";
                return moment(new Date(value)).format("DD.MM.YYYY");
            }
        },
        computed: {
            ...mapGetters({
                Loadings: 'ContractController/Loadings',
                relatedSupplier: 'ContractController/relatedSupplier',
                clientContractID: 'ContractController/ClientContractID',
                ListClientContract: 'ContractController/ListClientContract',
                ListSupplierContract: 'ContractController/ListSupplierContract',
            }),
        },
        watch: {
            clientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                this.setContractInfo(val);
                this.loadDebtorCode();
            },
            "attachmentLogo": function (val) {
                if (val) {
                    if (val.type !== 'image/jpeg' && val.type !== 'image/png' && val.type !== 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }

                    var _this = this;
                    const img = new Image();
                    img.onload = function() {
                        if(this.width > 180 || this.height > 180) {
                            _this.$alertNotification("The optimal image size is: 180 x 180", "warning");
                        }
                    }
                    img.src = URL.createObjectURL(val);

                    let data = {
                        url: {
                            original: URL.createObjectURL(val),
                            medium: URL.createObjectURL(val),
                            thumb: URL.createObjectURL(val)
                        }
                    };
                    
                    if(!this.clientContract.town_council_logo || !this.clientContract.town_council_logo.length)
                        this.clientContract.town_council_logo = [data]
                    else
                        this.clientContract.town_council_logo[0].url = data.url;
                }
            },
        },
        created() {
            if (!this.$route.params.hasOwnProperty('id') && isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-client`)
            }
            
            if(this.clientContractID && this.clientContractID.id) {
                this.setContractInfo(this.clientContractID);
                this.loadDebtorCode();
            } else {
                this.getContract()
            }
            this.getOrganizations({ is_supplier: false });
            this.getOrganizations({ is_supplier: true }, true);
        },
        methods: {
            getContract() {
                this.$store.dispatch('ContractController/getClientContract', this.$route.params.id)
                .then(response => {
                    this.setContractInfo(response.data.data);
                })
                .catch(error => {
                    this.$router.push(`/v2/contract-client`)
                })
            },
            formatData(temp, type ="base") {
                if(!temp || !temp.length) {
                    if(type == 'base') {
                        temp.push({
                            id: '',
                            term_type: type,
                            start_date: null,
                            end_date: null,
                            contract_sum: '',
                            sor_adjustment: '',
                            data: {}
                        });
                    }
                    return;
                }

                if(type == 'contract_variation_info') {
                    temp.forEach(function(item) {
                        item.json_content.amount = JSON.stringify(item.json_content.amount)
                    });
                    return;
                }

                //type: extra_info
                if(type == "extra_info") {
                    temp.forEach(function(item) {
                        //Security deposit
                        item.security_deposit.json_content.amount = JSON.stringify(item.security_deposit.json_content.amount);
                        //Work injury compensation
                        item.work_injury_compensation.json_content.policy_premium = JSON.stringify(item.work_injury_compensation.json_content.policy_premium)
                        item.work_injury_compensation.json_content.issue_date = item.work_injury_compensation.json_content.issue_date ? new Date(moment(item.work_injury_compensation.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.start_date = item.work_injury_compensation.json_content.start_date ? new Date(moment(item.work_injury_compensation.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.work_injury_compensation.json_content.end_date = item.work_injury_compensation.json_content.end_date ? new Date(moment(item.work_injury_compensation.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;

                        //Public liability claim insurance
                        item.public_liability_claim_insurance.json_content.policy_premium = JSON.stringify(item.public_liability_claim_insurance.json_content.policy_premium)
                        item.public_liability_claim_insurance.json_content.issue_date = item.public_liability_claim_insurance.json_content.issue_date ? new Date(moment(item.public_liability_claim_insurance.json_content.issue_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.start_date = item.public_liability_claim_insurance.json_content.start_date ? new Date(moment(item.public_liability_claim_insurance.json_content.start_date, "YYYY-MM-DD").toISOString()) : null;
                        item.public_liability_claim_insurance.json_content.end_date = item.public_liability_claim_insurance.json_content.end_date ? new Date(moment(item.public_liability_claim_insurance.json_content.end_date, "YYYY-MM-DD").toISOString()) : null;
                    });
                    return;
                }

                temp.forEach((item)  => {
                    item.contract_sum   = (item.contract_sum === 0 || !item.contract_sum) ?  '' : this.$accounting.formatMoney(item.contract_sum);
                    item.start_date     = (item.start_date != null) ? new Date(item.start_date) : null
                    item.end_date       = (item.end_date != null) ? new Date(item.end_date) : null
                    item.sor_adjustment = (item.sor_adjustment != null) ? parseFloat(parseFloat((item.sor_adjustment)*100).toFixed(2)) + "" : null;

                    if (item.extra_info) {
                        if (item.extra_info.loaDate) {
                            item.extra_info.loaDate = (item.extra_info.loaDate != null) ? new Date(item.extra_info.loaDate) : null;
                        }
                        if (item.extra_info.agreementDate) {
                            item.extra_info.agreementDate = (item.extra_info.agreementDate != null) ? new Date(item.extra_info.agreementDate) : null;
                        }
                        if (item.extra_info.clientLetterDate) {
                            item.extra_info.clientLetterDate = (item.extra_info.clientLetterDate != null) ? new Date(item.extra_info.clientLetterDate) : null;
                        }
                    }

                    //type: option, extension_period_main
                    if(type == 'option' || type == 'extension_period_main') {
                        let val = {
                            value: 'up',
                            label: 'Mark Up'
                        };

                        if(item.sor_adjustment < 0) {
                            item.sor_adjustment = item.sor_adjustment.replace("-", "")
                            val.value = 'down';
                            val.label = 'Mark Down';
                        }

                        item.type = val;
                    }
                });
            },
            setContractInfo(contract) {
                this.clientContract.security_deposit_main = this.clientContract.contact_variation_main = [];
                if (contract != null) {
                    this.formatData(contract.terms_base, 'base');
                    this.formatData(contract.terms_option, 'option');
                    this.formatData(contract.extension_period_main, 'extension_period_main');
                    this.formatData(contract.extra_info, 'extra_info');
                    this.formatData(contract.contract_variation_info, 'contract_variation_info');
                    this.clientContract = Object.assign({}, contract)
                    this.clientContract.contract_id = contract.id
                }
            },
            async getOrganizations(filter, is_supplier = false) {
                await this.$store.dispatch('OrganizationController/searchOrganizations', filter)
                .then(response => {
                    if(is_supplier)
                        this.clientsSupplier = response.data.data
                    else
                        this.clients = response.data.data
                })
                .catch(err => {})
            },
            searchOrganization(search, loading) {
                this.clients = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations({
                            is_supplier: false,
                            name: search
                        });
                        await loading(false);
                    } catch(err) {
                        await loading(false);
                    }
                }, 500);
            },
            searchOrganizationSupplier(search, loading) {
                this.clientsSupplier = []
                loading(true);
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations({
                            is_supplier: true,
                            name: search
                        }, true);
                        await loading(false);
                    } catch(err) {
                        await loading(false);
                    }
                }, 500);
            },
            addOption(key, type = 'option') {
                if(!this.clientContract[key]) return;
                let val = {
                    contract_id: this.$route.params.id,
                    id: null,
                    type: {
                        value: 'up',
                        label: 'Mark Up'
                    },
                    term_type: type,
                    start_date: null,
                    end_date: null,
                    contract_sum: '',
                    sor_adjustment: '',
                    extra_info: {}
                }

                if(type == 'extra_info') {
                    val = {
                        security_deposit : {
                            id: '',
                            section_name: 'Security Deposit',
                            json_content: {
                                type: '',
                                issuing_bank: '',
                                cheque_number: '',
                                amount: ''
                            }
                        },
                        work_injury_compensation: {
                            id: '',
                            section_name: 'Work Injury Compensation',
                            json_content: {
                                insurer: '',
                                policy_number: '',
                                issue_date: null,
                                policy_premium: '',
                                start_date: null,
                                end_date: null,
                                policy_receipt: ''
                            }
                        },
                        public_liability_claim_insurance: {
                            id: '',
                            section_name: 'Public Liability Claim Insurance',
                            json_content: {
                                insurer: '',
                                policy_number: '',
                                issue_date: null,
                                policy_premium: '',
                                start_date: null,
                                end_date: null,
                                policy_receipt: '',
                                copy_info_from: ''
                            }
                        }
                    };
                }

                if(type == 'contract_variation_info') {
                    val = {
                        id: '',
                        section_name: 'Contract Variation',
                        json_content: {
                            amount: '',
                            description: ''
                        }
                    };
                }
                
                this.clientContract[key].push(val)
            },
            removeOption(key, index, item = null) {
                if(!this.clientContract[key] || !this.clientContract[key].length) return;

                if(key == 'extra_info') {
                    if(item && item.security_deposit && item.security_deposit.id != 0) {
                        this.extra_info_ids.push(item.security_deposit.id);
                        this.extra_info_ids.push(item.work_injury_compensation.id);
                        this.extra_info_ids.push(item.public_liability_claim_insurance.id);
                    }
                }
                if(key == 'contract_variation_info' && item && item.id) {
                    this.extra_info_ids.push(item.id);
                }
                if(key == 'terms_option' && item && item.id){
                    if(this.clientContract.contract_term_id == item.id){
                        return this.$alertNotification("Can't delete term actived.", "danger");
                    }
                }
                if(key == 'extension_period_main' && item && item.id){
                    if(this.clientContract.contract_term_id == item.id){
                        return this.$alertNotification("Can't delete term actived.", "danger");
                    }
                }
                this.$delete(this.clientContract[key], index)
            },
            modalStatus() {
                this.contract_status = this.clientContract.status
                this.$refs['modal-Status'].show();
            },
            updateStatus() {
                if(this.isAction) return;
                if(!this.contract_status) {
                    return this.$alertNotification("Status is required.", "danger");
                }
                this.isAction = true;
                this.$store.dispatch('ContractController/updateStatusContract', { contract_id: this.clientContract.id, status: this.contract_status })
                    .then(response => {
                        this.isAction = false;
                        this.clientContract.status = this.contract_status;
                        this.ClientContractID.status = this.contract_status;
                        this.$refs['modal-Status'].hide();
                        return this.$alertNotification(this.$notificationV2('editing', 'client_contract'));
                    })
                    .catch(error => {
                        this.isAction = false;
                    });
            },
            selectClient(val) {
                if (val) {
                    this.clientContract.client = val
                    this.clientContract.client_id = val.id
                }
            },
            async saveTownCouncilLogo() {
                let request = {
                    attachment_id: this.clientContract.town_council_logo && this.clientContract.town_council_logo[0] && this.clientContract.town_council_logo[0].id ? this.clientContract.town_council_logo[0].id : 0,
                    contract_id: this.clientContract.id,
                    attachment: this.attachmentLogo,
                    attachmentType: "town_council_logo"
                }
                await this.$store.dispatch('ContractController/updateAttachments', request);
            },
            validattionDate() {
                /* Validate */
                if(!this.clientContract.terms_base.length) {
                    this.$alertNotification("There must be at least 1 base contract!", "danger");
                    return true;
                }
                
                let flag = false;
                if(!this.clientContract.terms_option.length && 
                    !this.clientContract.extension_period_main.length &&
                    this.clientContract.terms_base.length) {
                    for(let i = 0; i < this.clientContract.terms_base.length; i++) {
                        let item = this.clientContract.terms_base[i];
                        if(!item.start_date || !item.end_date) {
                            flag = true;
                            this.$alertNotification(`${!item.start_date ? 'Contract commencement date is required' : 'Contract expiry date is required'}`, "danger");
                            break;
                        }

                        if(moment(item.start_date).isAfter(item.end_date)) {
                            flag = true;
                            this.$alertNotification("Contract commencement date must be greater than contract expiry date", "danger");
                            break;
                        }
                    }
                    if(flag) return flag;
                }
                

                if(this.clientContract.terms_option.length) {
                    for(let i = 0; i < this.clientContract.terms_option.length; i++) {
                        let item = this.clientContract.terms_option[i];
                        if(!item.end_date) {
                            flag = true;
                            this.$alertNotification("Option period end date is required", "danger");
                            break;
                        }

                        if(i == 0) {
                            if(moment(this.clientContract.terms_base[0].end_date).isAfter(item.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than contract expiry date", "danger");
                                break;
                            }
                        } else {
                            /* Compare item prev*/
                            let item_prev = this.clientContract.terms_option[i - 1];
                            if(moment(item_prev.end_date).isAfter(item.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than previous option period end date", "danger");
                                break;
                            }
                        }

                        /* Compare item next*/
                        let item_next = null;
                        if( i != (this.clientContract.terms_option.length - 1) ) {
                            item_next = this.clientContract.terms_option[i + 1];
                        } else {
                            item_next = this.clientContract.extension_period_main.length ? this.clientContract.extension_period_main[0] : null;
                        }

                        if(item_next && item_next.end_date) {
                            if(moment(this.clientContract.terms_base[0].end_date).isAfter(item_next.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than contract expiry date", "danger");
                                break;
                            }

                            if(moment(item.end_date).isAfter(item_next.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be less than next option period end date", "danger");
                                break;
                            }
                        }
                    }
                    if(flag) return flag;
                }

                if(this.clientContract.extension_period_main.length) {
                    for(let i = 0; i < this.clientContract.extension_period_main.length; i++) {
                        let item = this.clientContract.extension_period_main[i];
                        if(!item.end_date) {
                            flag = true;
                            this.$alertNotification("Option period end date is required", "danger");
                            break;
                        }

                        if(i == 0) {
                            if(!this.clientContract.terms_option.length && moment(this.clientContract.terms_base[0].end_date).isAfter(item.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than contract expiry date", "danger");
                                break;
                            }

                            if(this.clientContract.terms_option.length && moment(this.clientContract.terms_option[0].end_date).isAfter(item.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than previous option period end date", "danger");
                                break;
                            }
                        } else {
                            /* Compare item prev*/
                            let item_prev = this.clientContract.extension_period_main[i - 1];
                            if(item.end_date && moment(item_prev.end_date).isAfter(item.end_date)) {
                                flag = true;
                                this.$alertNotification("Option period end date must be greater than previous option period end date", "danger");
                                break;
                            }
                        }

                        /* Compare item next*/
                        if(i != (this.clientContract.extension_period_main.length - 1)) {
                            let item_next = this.clientContract.extension_period_main[i + 1];
                            if(item_next.end_date) {
                                if(moment(this.clientContract.terms_base[0].end_date).isAfter(item_next.end_date)) {
                                    flag = true;
                                    this.$alertNotification("Option period end date must be greater than contract expiry date", "danger");
                                    break;
                                }

                                if(moment(item.end_date).isAfter(item_next.end_date)) {
                                    flag = true;
                                    this.$alertNotification("Option period end date must be less than next option period end date", "danger");
                                    break;
                                }
                            }
                        }
                    }
                }

                return flag;
            },
            async saveClientContract() {
                if(this.clientContract.abbreviation.length < 3){
                    return this.$alertNotification("Abbreviation must be 3 characters!", "danger");
                }
                this.$v.clientContract.$touch()
                if (!this.$v.clientContract.$error) {
                    let error = false, i, u;
                    for(i = 0; i < this.clientContract.extension_period_main.length ; i++ ) {
                        if(parseInt(this.clientContract.extension_period_main[i].sor_adjustment) > 100 && this.clientContract.extension_period_main[i].type.value == 'down') {
                            error = true;
                            break;
                        }
                    }
                    for(u = 0; u < this.clientContract.terms_option.length ; u++ ) {
                        if(parseInt(this.clientContract.terms_option[u].sor_adjustment) > 100 && this.clientContract.terms_option[u].type.value == 'down') {
                            error = true;
                            break;
                        }
                    }
                    if( error ) {
                        return this.$alertNotification("Mark Down: can't input SOR Adjustment > 100%", "danger");
                    }

                    let is_unvalid = this.validattionDate();
                    if(is_unvalid) {
                        return;

                    }

                    this.disabled = true
                    let contractRequest = Object.assign({}, this.clientContract)
                    contractRequest.settings = JSON.stringify(contractRequest.settings);
                    contractRequest.case_settings = JSON.stringify(contractRequest.case_settings);
                    contractRequest.extra_info_ids = this.extra_info_ids
                    contractRequest.terms_base = Object.assign({}, this.clientContract.terms_base)
                    contractRequest.terms_option = Object.assign({}, this.clientContract.terms_option)

                    delete contractRequest.maintenance_settings
                    delete contractRequest.case_hot_button_settings
                    
                    if (this.clientContract.terms_base.length > 0) {
                        contractRequest.terms_base = [];
                        this.clientContract.terms_base.forEach((item) => {
                            let obj = Object.assign({}, item);
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : ''
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : '';
                            /*if(obj.data){
                              if(obj.data.loaDate){
                                obj.data.loaDate = (obj.data.loaDate !== null) ? moment(obj.data.loaDate).format('YYYY-MM-DD') : '';
                              }
                              if(obj.data.agreementDate){
                                obj.data.agreementDate = (obj.data.agreementDate !== null) ? moment(obj.data.agreementDate).format('YYYY-MM-DD') : '';
                              }
                              if(obj.data.clientLetterDate){
                                obj.data.clientLetterDate = (obj.data.clientLetterDate !== null) ? moment(obj.data.clientLetterDate).format('YYYY-MM-DD') : '';
                              }
                            }*/
                            contractRequest.terms_base.push(obj)
                        });
                    }

                    if (this.clientContract.terms_option.length > 0) {
                        contractRequest.terms_option = [];
                        this.clientContract.terms_option.forEach(function(item) {
                            let obj = Object.assign({}, item)
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : '';
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : '';
                            if(obj.type && obj.type.value === 'down'){
                                obj.sor_adjustment = '-'+obj.sor_adjustment
                            }
                            delete(obj.type)
                            /*if(obj.data){
                              if(obj.data.loaDate){
                                obj.data.loaDate = (obj.data.loaDate !== null) ? moment(obj.data.loaDate).format('YYYY-MM-DD') : '';
                              }
                              if(obj.data.agreementDate){
                                obj.data.agreementDate = (obj.data.agreementDate !== null) ? moment(obj.data.agreementDate).format('YYYY-MM-DD') : '';
                              }
                              if(obj.data.clientLetterDate){
                                obj.data.clientLetterDate = (obj.data.clientLetterDate !== null) ? moment(obj.data.clientLetterDate).format('YYYY-MM-DD') : '';
                              }
                            }*/
                            contractRequest.terms_option.push(obj)
                        });
                    }

                    if (this.clientContract.extension_period_main.length > 0) {
                        contractRequest.extension_period_main = [];
                        this.clientContract.extension_period_main.forEach(function(item) {
                            let obj = Object.assign({}, item)
                            obj.contract_sum = accounting.unformat(obj.contract_sum)
                            obj.start_date = (obj.start_date != null) ? moment(new Date(obj.start_date)).format('YYYY-MM-DD') : '';
                            obj.end_date = (obj.end_date != null) ? moment(new Date(obj.end_date)).format('YYYY-MM-DD') : '';
                            if(obj.type && obj.type.value === 'down'){
                                obj.sor_adjustment = '-'+obj.sor_adjustment
                            }
                            delete(obj.type)
                            contractRequest.extension_period_main.push(obj)
                        });
                    }

                    if (this.clientContract.extra_info.length > 0) {
                        contractRequest.extra_info = [];
                        this.clientContract.extra_info.forEach(function(item) {
                            let obj = JSON.parse(JSON.stringify(item));
                            //Security deposit
                            obj.security_deposit.json_content.amount = accounting.unformat(obj.security_deposit.json_content.amount)

                            //Work injury compensation
                            obj.work_injury_compensation.json_content.policy_premium = accounting.unformat(obj.work_injury_compensation.json_content.policy_premium)
                            obj.work_injury_compensation.json_content.issue_date = obj.work_injury_compensation.json_content.issue_date ? moment(new Date(obj.work_injury_compensation.json_content.issue_date)).format('YYYY-MM-DD') : '';
                            obj.work_injury_compensation.json_content.start_date = obj.work_injury_compensation.json_content.start_date ? moment(new Date(obj.work_injury_compensation.json_content.start_date)).format('YYYY-MM-DD') : '';
                            obj.work_injury_compensation.json_content.end_date = obj.work_injury_compensation.json_content.end_date ? moment(new Date(obj.work_injury_compensation.json_content.end_date)).format('YYYY-MM-DD') : '';

                            //Public liability claim insurance
                            obj.public_liability_claim_insurance.json_content.policy_premium = accounting.unformat(obj.public_liability_claim_insurance.json_content.policy_premium)
                            obj.public_liability_claim_insurance.json_content.issue_date = obj.public_liability_claim_insurance.json_content.issue_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.issue_date)).format('YYYY-MM-DD') : '';
                            obj.public_liability_claim_insurance.json_content.start_date = obj.public_liability_claim_insurance.json_content.start_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.start_date)).format('YYYY-MM-DD') : '';
                            obj.public_liability_claim_insurance.json_content.end_date = obj.public_liability_claim_insurance.json_content.end_date ? moment(new Date(obj.public_liability_claim_insurance.json_content.end_date)).format('YYYY-MM-DD') : '';

                            obj.security_deposit.json_content = JSON.stringify(obj.security_deposit.json_content)
                            obj.work_injury_compensation.json_content = JSON.stringify(obj.work_injury_compensation.json_content)
                            obj.public_liability_claim_insurance.json_content = JSON.stringify(obj.public_liability_claim_insurance.json_content)
                            contractRequest.extra_info.push(obj.security_deposit)
                            contractRequest.extra_info.push(obj.work_injury_compensation)
                            contractRequest.extra_info.push(obj.public_liability_claim_insurance)
                        });
                    }

                    if(this.clientContract.contract_variation_info.length > 0) {
                        contractRequest.contract_variation_info = [];
                        this.clientContract.contract_variation_info.forEach(function(item) {
                            let obj = JSON.parse(JSON.stringify(item));
                            obj.json_content.amount = accounting.unformat(obj.json_content.amount)
                            obj.json_content = JSON.stringify(obj.json_content)
                            contractRequest.contract_variation_info.push(obj)
                        });
                    }

                    contractRequest.deposit_expiry   = contractRequest.deposit_expiry ? contractRequest.deposit_expiry.toISOString().split('T')[0] : '';
                    contractRequest.insurance_expiry = contractRequest.insurance_expiry ? contractRequest.insurance_expiry.toISOString().split('T')[0] : '';
                    if(this.attachmentLogo) {
                        await this.saveTownCouncilLogo();
                    }
                    await this.$store.dispatch('ContractController/UpdateClientContract', contractRequest)
                        .then(response => {
                            this.disabled = false
                            if(response.data.data.code)
                                return this.$alertNotification(response.data.data.message, "danger");
                            
                            this.extra_info_ids = [];
                            this.getContract();
                            if (response.data.status == 200) {
                                this.$nextTick(() => {
                                    this.$v.clientContract.$reset()
                                })
                                this.$store.dispatch('ContractController/getListclientcontracts', [this.ListClientContract.currentPage, this.ListClientContract.filter, this.ListClientContract.limit, '1'] );
                                return this.$alertNotification(this.$notificationV2('editing', 'client_contract'));
                            }
                        })
                        .catch(error => {
                            this.disabled = false
                            if(error.response) this.$alertNotification(error, "danger");
                        });
                }
            },
            relatedSuppliers() {
                if (this.$route.params.id != this.relatedSupplier.contract_id || this.clientContract.related_supplier_contracts_count != this.relatedSupplier.total) {
                    this.$store.dispatch('ContractController/getRelatedSupplier', {
                        contract_id: this.$route.params.id,
                        contract_type: 's_contract'
                    })
                    .then(response=>{
                        if(this.relatedSupplier.data) {
                            const _this = this;
                            this.relatedSupplier.data.map(function(item) {
                                _this.listIDSupplierRelated.push(item.supplier_id);
                            });
                        }
                    })
                }
                this.$bvModal.show('search-client')
            },
            selectOrganization(val){
                this.supplier.client_id = (val && val.hasOwnProperty('id')) ? val.id : ''
            },
            creatSupplierQuick() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                if(!this.clientsSupplierSelected) {
                    this.$refs['modal-confirm'].hide();
                    return this.$alertNotification("Please select supplier", "danger");
                }
                this.timer = setTimeout(() => {
                    this.$refs['modal-confirm'].hide()
                    let supplier = {
                        contract_id: this.$route.params.id,
                        client_id: this.clientsSupplierSelected.id,
                        type: this.type ? this.type.value : 'down',
                        sor_adjustment: this.sor_adjustment ? this.sor_adjustment.replace("%", "") : ''
                    }
                    if(this.clientsSupplierSelected.id) {
                        this.listIDSupplierRelated.push(this.clientsSupplierSelected.id);
                    }
                    this.isAction = true
                    this.$store.dispatch('ContractController/CreateSupplierContract', supplier)
                        .then(response => {
                            this.$store.dispatch('ContractController/getRelatedSupplier', {
                                contract_id: this.$route.params.id,
                                contract_type: 's_contract'
                            })
                            this.isAction = false
                            this.$store.dispatch('ContractController/getListSupplierContracts', [this.ListSupplierContract.currentPage, this.ListSupplierContract.filter, this.ListSupplierContract.limit,1], '1')
                            this.clientContract.related_supplier_contracts_count += 1
                            return this.$alertNotification(this.$notificationV2('adding', 'supplier_contract'));
                        })
                        .catch(error => {
                            this.isAction = false
                        });
                }, 500)
            },
            clonePublic(index) {
                if(this.clientContract.extra_info[index]) {
                    if(this.selectedClone) {
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content = {
                            insurer: '',
                            policy_number: '',
                            issue_date: null,
                            policy_premium: '',
                            start_date: null,
                            end_date: null,
                            policy_receipt: '',
                            copy_info_from: ''
                        }
                    }else {
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content = JSON.parse(JSON.stringify(this.clientContract.extra_info[index].work_injury_compensation.json_content));
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.copy_info_from = new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.copy_info_from)
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.issue_date) : null
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.start_date) : null
                        this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date = this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date ? new Date(this.clientContract.extra_info[index].public_liability_claim_insurance.json_content.end_date) : null
                    }
                }
                this.selectedClone = !this.selectedClone
            },
            print () {
                this.$refs.contractPrint.print();
            },
            loadDebtorCode(search = null){
                let filter = {
                    source_type: "C",
                    is_blocked: 0,
                    source_code: search || null,
                    contract_id: this.clientContract ? this.clientContract.id : null,
                };
                let params = {
                  filter: filter,
                  limit: 50,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                    .then(response => {
                      this.debtorCodeOptions = response.items;
                    })
            },
            // async downloadFile(attachment) {
            //     let url = attachment.url.original;
            //     let params = {};
            //     params.url = url;
            //     params.image_file_name = attachment.image_file_name;

            //         await this.$store.dispatch("FileDownloadController/getFile", params)
            //     .then(response => {
            //     })
            //     .catch(err => {
            //         this.$alertNotification("Can not download file", "danger");
            //         console.log(err);
            //     })
            // },
        }
    }
</script>
